import React from "react";
import { SocialSubscribersTable } from "./SocialSubscribersTable";

export const SocialSubscribers = ({ details }) => {
  return (
    <div className="col d-flex flex-column h-100 w-100 pt-8">
      <SocialSubscribersTable details={details} />
    </div>
  );
};
